/* Egoé Nest dealer map — Leaflet + OpenStreetMap (no Google API).
 * Replaces theme's g-map element with native Leaflet implementation.
 * Pre-geocoded coords baked in (no runtime geocoding).
 * Click pin → popup with title/address/contact/web button.
 */
(function () {
  if (window.__nestLeafletInit) return;
  window.__nestLeafletInit = true;

  // Country centers for initial map focus per locale
  var COUNTRY_CENTERS = {
    CZ: { lat: 49.8175, lng: 15.4730, zoom: 7 },
    SK: { lat: 48.6690, lng: 19.6990, zoom: 7 },
    DE: { lat: 51.1657, lng: 10.4515, zoom: 6 },
    AT: { lat: 47.5162, lng: 14.5501, zoom: 7 },
    FR: { lat: 46.6034, lng: 1.8883, zoom: 6 },
    EU: { lat: 50.0,    lng: 10.0,   zoom: 5 }
  };

  function getLocale() {
    var lang = (document.documentElement.lang || '').toLowerCase();
    if (lang.indexOf('cs') === 0 || lang.indexOf('sk') === 0) return 'CZ';
    if (lang.indexOf('de') === 0) return 'DE';
    if (lang.indexOf('fr') === 0) return 'FR';
    if (lang.indexOf('en') === 0) return 'EU';
    return 'CZ';
  }

  // Pre-geocoded dealer coords (29 addresses)
  var DEALER_COORDS = {
  "Brusselsesteenweg 602, 9050 Gent, Austria": {
    "lat": 51.0538286,
    "lng": 3.7250121,
    "display": "Gent, Oost-Vlaanderen, Vlaanderen, België / Belgique / Belgien",
    "fallback": "Gent, Belgium"
  },
  "Gewerbestraße 8, 4842 Zell am Pettenfirst, Austria": {
    "lat": 48.0703977,
    "lng": 13.5972794,
    "display": "8, Gewerbestraße, Zell am Pettenfirst, Bezirk Vöcklabruck, Oberösterreich, 4842,"
  },
  "Goldenberg  1, A - 4070 Eferding, Austria": {
    "lat": 48.3082607,
    "lng": 14.0203999,
    "display": "Eferding, Bezirk Eferding, Oberösterreich, 4070, Österreich",
    "fallback": "Eferding, Austria"
  },
  "Frans Verbeekstraat 251, 3090 Overijse, Belgium": {
    "lat": 50.7690934,
    "lng": 4.5092724,
    "display": "Frans Verbeekstraat, Overijse, Wezembeek-Oppem, Halle-Vilvoorde, Vlaams-Brabant,"
  },
  "Route Zénobe Gramme 32, 4821 Andrimont, Belgium": {
    "lat": 50.6141349,
    "lng": 5.8828112,
    "display": "Andrimont, Dison, Verviers, Liège, Wallonie, 4821, België / Belgique / Belgien",
    "fallback": "Andrimont, Belgium"
  },
  "Eluf Nielsens vej 4, 6920 Videbæk, Denmark": {
    "lat": 56.096311,
    "lng": 8.615863,
    "display": "4, Eluf Nielsens Vej, Videbæk, Ringkøbing-Skjern Kommune, Region Midtjylland, 69"
  },
  "11 Avenue d´Hermés, 31240 L'Union, France": {
    "lat": 43.638593,
    "lng": 1.497421,
    "display": "11, Avenue d'Hermès, ZA de Montredon, L'Union, Toulouse, Haute-Garonne, Occitani"
  },
  "ZA Saint-Memain 28150 VOVES, France": {
    "lat": 48.264,
    "lng": 1.6212,
    "display": "Voves, France (manual)"
  },
  "430 rue du Companet, 69140 Lyon, France": {
    "lat": 45.8119125,
    "lng": 4.8813089,
    "display": "430, Rue du Companet, Mercières Victor Hugo Loup Pendu, Crépieux-la-Pape, Rillie"
  },
  "ZA Le Fief aux Moines D745, 85240 Saint-Hilaire-des-Loges, France": {
    "lat": 46.4706005,
    "lng": -0.6656039,
    "display": "Saint-Hilaire-des-Loges, Fontenay-le-Comte, Vendée, Pays de la Loire, France mét",
    "fallback": "Saint-Hilaire-des-Loges, France"
  },
  "42 rue de la Jouardais, 44640 Le Pellerin, France": {
    "lat": 47.1965185,
    "lng": -1.7587228,
    "display": "42, Rue de la Jouardais, Le Pré Louiseau, Le Pellerin, Nantes, Loire-Atlantique,"
  },
  "Za la peyrelade, 11 rue des 3 moulins, 11110 Armissan, France": {
    "lat": 43.186,
    "lng": 3.09765,
    "display": "Armissan, Narbonne, Aude, Occitanie, France métropolitaine, 11110, France",
    "fallback": "Armissan, France"
  },
  "23 avenue de Nantes, 49300 Cholet, France": {
    "lat": 47.0606423,
    "lng": -0.8934973,
    "display": "23, Avenue de Nantes, Cholet, Maine-et-Loire, Pays de la Loire, France métropoli"
  },
  "6 rue de la ZA Picot, 33160 Saint-Médard-en-Jalles, France": {
    "lat": 44.8958887,
    "lng": -0.7170764,
    "display": "Saint-Médard-en-Jalles, Bordeaux, Gironde, Nouvelle-Aquitaine, France métropolit",
    "fallback": "Saint-Médard-en-Jalles, France"
  },
  "Lindenweg 1, 19075 Pampow/ Schwerin, Germany": {
    "lat": 53.5624711,
    "lng": 11.3877467,
    "display": "Neu Pampow, Schwerin, Mecklenburg-Vorpommern, 19075, Deutschland",
    "fallback": "Pampow/ Schwerin, Germany"
  },
  "Hauptstraße 62, 57584 Wallmenrorth, Germany": {
    "lat": 50.7758,
    "lng": 7.819,
    "display": "Wallmenroth, Germany (manual)"
  },
  "Bahnhofstr. 47, 65552 Limburg-Eschhofen, Germany": {
    "lat": 50.3932751,
    "lng": 8.1070475,
    "display": "Pizzeria Capri, 47, Bahnhofstraße, Eschhofen, Limburg an der Lahn, Landkreis Lim"
  },
  "Günther Irmscher-Strasse 14-22, 73630 Remshalden, Germany": {
    "lat": 48.8122773,
    "lng": 9.4204364,
    "display": "Günther-Irmscher-Straße, Grunbach, Remshalden, Rems-Murr-Kreis, Baden-Württember"
  },
  "Dieselstraße 3, 90592 Schwarzenbruck, Germany": {
    "lat": 49.3495696,
    "lng": 11.2617232,
    "display": "Dieselstraße, Gewerbegebiet Mittellandholz, Ochenbruck, Schwarzenbruck, Landkrei"
  },
  "Heckerstieg 3, 99085 Erfurt, Germany": {
    "lat": 50.9908606,
    "lng": 11.0459672,
    "display": "3, Heckerstieg, Johannesvorstadt, Erfurt, Thüringen, 99085, Deutschland"
  },
  "Freibühlstraße 14, 78224 Singen, Germany": {
    "lat": 47.7547165,
    "lng": 8.8649414,
    "display": "Van2Go, 14, Freibühlstraße, Singen (Hohentwiel), VVG der Stadt Singen (Hohentwie"
  },
  "Fiduciastrasse 8a, D-76227 Karlsruhe, Germany": {
    "lat": 49.0068705,
    "lng": 8.4034195,
    "display": "Karlsruhe, Baden-Württemberg, Deutschland",
    "fallback": "Karlsruhe, Germany"
  },
  "Alte Moritzburger Straße 8, 01108 Dresden-Weixdorf, Germany": {
    "lat": 51.150183,
    "lng": 13.8000173,
    "display": "Das Anhängercenter GmbH, 8, Alte Moritzburger Straße, Altweixdorf, Lausa, Weixdo"
  },
  "Hoheneichstraße 48, 75217 Birkenfeld, Germany": {
    "lat": 48.8863731,
    "lng": 8.6348248,
    "display": "48, Hoheneichstraße, Interkommunales Gewerbegebiet Dammfeld, Birkenfeld, Keltern"
  },
  "Brittas Bay, Wicklow Town, Ireland": {
    "lat": 52.9802376,
    "lng": -6.0414184,
    "display": "Wicklow, County Wicklow, Leinster, Éire / Ireland",
    "fallback": "Wicklow Town, Ireland"
  },
  "215 Upper Rathmines Road, D06 Y9W2 Dublin, Ireland": {
    "lat": 53.3142622,
    "lng": -6.2646309,
    "display": "215, Rathmines Road Upper, Rathgar, Rathmines West D ED, Dublin, County Dublin, "
  },
  "Delfweg 12, 2211VM Noordwijkerhout, Netherland": {
    "lat": 52.2598,
    "lng": 4.4863,
    "display": "Noordwijkerhout, Netherlands (manual)"
  },
  "Strandallén 4, 135 61 Tyresö, Sweden": {
    "lat": 59.2458316,
    "lng": 18.2746049,
    "display": "Delikatessboden i Tyresö, 4, Strandallén, Strand, Tyresö strand, Tyresö, Tyresö "
  }
};

  // Egoé HQ pin (always show, regardless of dealer list)
  var EGOE_HQ = {
    lat: 49.2471,
    lng: 16.6724,
    title: 'Egoé Nest — výroba & showroom',
    address: 'Bílovice nad Svitavou, Česká republika',
    web: 'https://www.egoe.eu',
    isHQ: true
  };

  function buildPopupHtml(data) {
    var html = '<div class="nest-pop">';
    if (data.isHQ) {
      html += '<div class="nest-pop__badge">Hlavné sídlo</div>';
    }
    if (data.title) {
      html += '<div class="nest-pop__title">' + escapeHtml(data.title) + '</div>';
    }
    if (data.address) {
      html += '<div class="nest-pop__addr">' + escapeHtml(data.address) + '</div>';
    }
    if (data.contact) {
      html += '<div class="nest-pop__contact">' + data.contact + '</div>';
    }
    var actions = '<div class="nest-pop__actions">';
    if (data.web) {
      actions += '<a class="nest-pop__btn nest-pop__btn--primary" href="' + escapeAttr(data.web) + '" target="_blank" rel="noopener">Web dealera</a>';
    }
    if (data.address) {
      actions += '<a class="nest-pop__btn nest-pop__btn--secondary" href="https://www.openstreetmap.org/?mlat=' + data.lat + '&mlon=' + data.lng + '#map=17/' + data.lat + '/' + data.lng + '" target="_blank" rel="noopener">Mapa</a>';
    }
    actions += '</div>';
    html += actions + '</div>';
    return html;
  }

  function escapeHtml(s) {
    return String(s||'').replace(/[&<>"']/g, function(c){return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c];});
  }
  function escapeAttr(s) { return escapeHtml(s); }

  function loadCss(href) {
    if (document.querySelector('link[href="'+href+'"]')) return;
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = href;
    document.head.appendChild(l);
  }

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      if (window.L) return resolve();
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  function injectStyles() {
    if (document.getElementById('nest-leaflet-style')) return;
    var s = document.createElement('style');
    s.id = 'nest-leaflet-style';
    s.textContent = ''
      + '.nest-leaflet-map { width: 100%; height: 100%; min-height: 500px; border-radius: inherit; z-index: 1; }'
      + '@media (max-width: 768px) { .nest-leaflet-map { min-height: 420px; } }'
      + '.nest-pop { font-family: inherit; max-width: 280px; line-height: 1.45; padding: 4px; }'
      + '.nest-pop__badge { display:inline-block; background:#ff6521; color:#fff; font-size:10px; font-weight:600; text-transform:uppercase; letter-spacing:0.05em; padding:3px 8px; border-radius:9999px; margin-bottom:6px; }'
      + '.nest-pop__title { font-weight: 600; font-size: 15px; color: #1e1e1e; margin-bottom: 6px; }'
      + '.nest-pop__addr { font-size: 13px; color: #555; margin-bottom: 8px; }'
      + '.nest-pop__contact { font-size: 12px; color: #444; margin-bottom: 10px; }'
      + '.nest-pop__contact a { color: #1e1e1e; text-decoration: underline; }'
      + '.nest-pop__actions { display: flex; gap: 8px; flex-wrap: wrap; margin-top: 4px; }'
      + '.nest-pop__btn { display: inline-flex; align-items: center; padding: 8px 14px; font-size: 12px; font-weight: 600; border-radius: 9999px; text-decoration: none !important; transition: background 120ms ease; }'
      + '.nest-pop__btn--primary { background: #1e1e1e; color: #fff !important; }'
      + '.nest-pop__btn--primary:hover { background: #000; }'
      + '.nest-pop__btn--secondary { background: #fff; color: #1e1e1e !important; border: 1.5px solid #1e1e1e; }'
      + '.nest-pop__btn--secondary:hover { background: #efe9e0; }'
      + '.leaflet-popup-content-wrapper { border-radius: 12px !important; box-shadow: 0 6px 20px rgba(0,0,0,0.12) !important; padding: 4px !important; }'
      + '.leaflet-popup-content { margin: 12px 14px !important; min-width: 240px; }'
      + '.leaflet-popup-tip { box-shadow: 0 6px 20px rgba(0,0,0,0.12) !important; }'
      + '.nest-pin { background: transparent; border: none; }'
      + '@media (max-width: 768px) { .nest-pop { max-width: 230px; } .nest-pop__btn { font-size: 11px; padding: 7px 12px; } }';
    document.head.appendChild(s);
  }

  function createPinIcon(L, color) {
    var svgIcon = '<svg width="32" height="42" viewBox="0 0 46 50" xmlns="http://www.w3.org/2000/svg"><path fill="'+color+'" stroke="#1e1e1e" stroke-width="1.5" d="M22.6746 0C10.2174 0 0 8.79169 0 21.5118C0 31.2116 4.33864 38.333 9.26606 42.998C11.7232 45.3243 14.3387 47.0534 16.6674 48.2077C18.9384 49.3333 21.1148 50 22.6746 50C24.2345 50 26.4108 49.3333 28.6818 48.2077C31.0105 47.0534 33.626 45.3243 36.0832 42.998C41.0106 38.333 45.3492 31.2116 45.3492 21.5118C45.3492 8.79169 35.1318 0 22.6746 0Z"/><circle cx="22.6746" cy="21.5118" r="6.97" fill="#fff"/></svg>';
    return L.divIcon({
      className: 'nest-pin',
      html: svgIcon,
      iconSize: [32, 42],
      iconAnchor: [16, 42],
      popupAnchor: [0, -38]
    });
  }

  function extractListItemData(item, address) {
    if (!item) return { title: '', address: address, contact: '', web: '' };
    var clone = item.cloneNode(true);
    clone.querySelectorAll('.sr-only, [data-map-button]').forEach(function (el) { el.remove(); });
    var titleEl = clone.querySelector('.h4, p.h4, h4');
    var addrEl = clone.querySelector('address');
    var contactEl = clone.querySelector('.rte, .help-list__contact');
    var linkEl = item.querySelector('[data-map-button], a[href]:not([data-map-button-skip])');
    return {
      title: titleEl ? titleEl.textContent.trim() : '',
      address: addrEl ? addrEl.textContent.trim().replace(/\s+/g, ' ') : address,
      contact: contactEl ? contactEl.innerHTML : '',
      web: (linkEl && linkEl.href) ? linkEl.href : ''
    };
  }

  function initMap() {
    var gMaps = document.querySelectorAll('g-map');
    if (!gMaps.length) return;

    injectStyles();
    loadCss('https://unpkg.com/leaflet@1.9.4/dist/leaflet.css');

    loadScript('https://unpkg.com/leaflet@1.9.4/dist/leaflet.js').then(function () {
      var L = window.L;
      var locale = getLocale();
      var focus = COUNTRY_CENTERS[locale] || COUNTRY_CENTERS.EU;

      gMaps.forEach(function (gmap) {
        // Replace g-map with leaflet div, preserving size + container styles.
        var parent = gmap.parentNode;
        var leafletDiv = document.createElement('div');
        leafletDiv.className = 'nest-leaflet-map';
        leafletDiv.style.cssText = 'width:100%;height:100%;min-height:inherit;border-radius:inherit;';
        parent.replaceChild(leafletDiv, gmap);

        // Find associated dealer list
        var id = gmap.id;
        var list = null;
        if (id) {
          list = document.querySelector('[aria-controls="' + id + '"][is="g-map-locations"]') ||
                 document.querySelector('ul[aria-controls="' + id + '"]');
        }

        var entries = [];
        if (list) {
          list.querySelectorAll('[data-map-address]').forEach(function (el) {
            var a = el.getAttribute('data-map-address');
            if (a && DEALER_COORDS[a]) {
              entries.push({ address: a, item: el, coords: DEALER_COORDS[a] });
            }
          });
        }

        // Init map at locale country center
        var map = L.map(leafletDiv, {
          center: [focus.lat, focus.lng],
          zoom: focus.zoom,
          scrollWheelZoom: true,
          tap: true
        });

        // Tiles: Carto Voyager (clean, free)
        L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
          subdomains: 'abcd',
          maxZoom: 19
        }).addTo(map);

        var markersByAddr = {};

        // Add Egoé HQ first
        var hqMarker = L.marker([EGOE_HQ.lat, EGOE_HQ.lng], { icon: createPinIcon(L, '#ff6521') })
          .addTo(map)
          .bindPopup(buildPopupHtml(EGOE_HQ), { maxWidth: 320, autoPan: true });
        markersByAddr['__egoe_hq__'] = hqMarker;

        // Add dealer markers
        entries.forEach(function (e) {
          var data = extractListItemData(e.item, e.address);
          data.lat = e.coords.lat;
          data.lng = e.coords.lng;
          var marker = L.marker([e.coords.lat, e.coords.lng], { icon: createPinIcon(L, '#1e1e1e') })
            .addTo(map)
            .bindPopup(buildPopupHtml(data), { maxWidth: 320, autoPan: true });
          markersByAddr[e.address] = marker;
        });

        // Wire up dealer list clicks (open popup, no zoom)
        if (list) {
          list.querySelectorAll('[data-map-address]').forEach(function (item) {
            item.addEventListener('click', function (event) {
              if (event.target.closest('a[href]') || event.target.closest('[data-map-button]')) return;
              event.stopImmediatePropagation();
              var addr = item.getAttribute('data-map-address');
              var marker = markersByAddr[addr];
              if (marker) {
                list.querySelectorAll('.active').forEach(function (el) { el.classList.remove('active'); });
                item.classList.add('active');
                map.panTo(marker.getLatLng(), { animate: true });
                marker.openPopup();
              }
            }, true);
          });
        }
      });
    }).catch(function (e) {
      console.error('Leaflet failed to load', e);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMap);
  } else {
    initMap();
  }
})();
